<div class="loader-licenses" *ngIf="gettingLicenses" style="margin-top: 50px !important;">
  <app-loader></app-loader>
</div>

<div class="loader-licenses" *ngIf="selectedUserLicenses.length === 0 && !gettingLicenses">
  <br>
  <h1 class="u-mb30 txt txt--title"> Licencias </h1>
  <p *ngIf="gettingLicensesError !== '' "> {{gettingLicensesError }} </p>
  <p *ngIf="gettingLicensesError === '' ">No hay licencias registradas.</p>
  <a *ngIf="gettingLicensesError === '' " type="button" class="btn btn--primary" routerLink="/license/new">Crear
    una nueva solicitud de
    licencia</a>
</div>


<app-search-driver-licenses-home *ngIf="!gettingLicenses && selectedUserLicenses.length > 0"
  [completeLicenseData]="selectedUserLicenses" [zonesRows]="zonesRows" [personData]="personData"
  (refreshLicenseCards)="getLicenseBySelectedUser(true)"
  >
</app-search-driver-licenses-home>

